
<nz-result nzStatus="404" [nzTitle]="title" [nzSubTitle]="subtitle">
	<div nz-result-extra>
		<button style="margin: 0 auto;" (click)="back()" nz-button nzType="primary">Back</button>
	</div>
</nz-result>
